import { type KeyPress } from '@/utils/keyboard-util'
import { type Observable } from 'rxjs'
import { filter, share } from 'rxjs/operators'

/**
 * Shortcuts manager.
 */
export class Shortcuts {
  /**
   * Rename shortcut.
   */
  readonly rename$

  constructor(keyboard$: Observable<KeyPress>) {
    this.rename$ = keyboard$.pipe(matches({ key: 'F2' }), share())
  }
}

/**
 * Checks for a match.
 *
 * @param target
 */
function matches(target: Partial<KeyPress>) {
  return filter<KeyPress>((e) => {
    let isMatch = true
    if (isMatch && target.key !== undefined) {
      isMatch = target.key === e.key
    }

    if (isMatch && target.alt !== undefined) {
      isMatch = target.alt === e.alt
    }

    if (isMatch && target.shift !== undefined) {
      isMatch = target.shift === e.shift
    }

    if (isMatch && target.ctrl !== undefined) {
      isMatch = target.ctrl === e.ctrl
    }

    if (isMatch && target.meta !== undefined) {
      isMatch = target.meta === e.meta
    }

    return isMatch
  })
}
